/*
    Convert time string to date object with random year, month and day
*/
export function convertTimeToDateUTC(time: string) {
    const date = new Date();

    date.setUTCHours(
        parseInt(time.split(":")[0]),
        parseInt(time.split(":")[1]),
        0,
        0,
    );

    return date;
}

/*
    Convert time string to date object with random year, month and day
*/
export function convertTimeToDate(time: string) {
    const date = new Date();

    date.setHours(
        parseInt(time.split(":")[0]),
        parseInt(time.split(":")[1]),
        0,
        0,
    );

    return date;
}
